import React from "react";
import UserMessage from "./UserMessage";
import AiMessage from "./AiMessage";
import InputBoxMessage from "./InputBoxMessage";
import style from "../Chat.module.css";
import CircularProgress from '@mui/material/CircularProgress';
import imgAvata from '../../../../images/common/img_chat_mascot.svg';

function ChatListComp({
    chatList,
    handleClickFeedback,
    queueStatus,
    handleInputBoxSubmit,
    handleTagClick
}) {
    return (
        <>
            {chatList.map((chat, index) => {
                const key =
                    chat.id ||
                    `${chat.type}-${chat.date ?? ""}-${index}`;

                if (chat.type === "date") {
                    return (
                        <div
                            key={key}
                            className={style["hr-line"]}
                            data-line-order="first"
                        >
                            <span>{chat.dateStr}</span>
                        </div>
                    );
                }

                if (chat.type === "bot" && chat.source === "init") {
                    return (
                        <div key={key} className={style["ai-talk-box"]}>
                            <strong className={style['ai-avatar']}>
                                <img src={imgAvata} alt="ai 아바타" />
                            </strong>
                            
                            <div className={style["ai-box"]}>
                                <div className={style["text-box"]}>
                                    <div className={style["p-group"]}>
                                        <p>{chat.text}</p>
                                    </div>

                                    <span className={style["date-txt"]}>
                                        {chat.chatTime}
                                    </span>
                                </div>

                                {chat.tags && (
                                    <div
                                        className={style["inform-box"]}
                                        data-type="b"
                                    >
                                        
                                        <ul>
                                            {chat.tags.map((tag, tagIndex) => (
                                                <li
                                                    key={`${tag}-${tagIndex}`}
                                                >
                                                    {tag}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                }

                if (
                    chat.type === "bot" &&
                    chat.responseType === "input_box"
                ) {
                    return (
                        <InputBoxMessage
                            key={key}
                            chatInfo={chat}
                            onSubmit={handleInputBoxSubmit}
                        />
                    );
                }

                if (chat.type === "user") {
                    return (
                        <UserMessage
                            key={key}
                            chatInfo={chat}
                        />
                    );
                }

                return (
                    <AiMessage
                        key={key}
                        chatInfo={chat}
                        handleClickFeedback={handleClickFeedback}
                        handleTagClick={handleTagClick}
                        queueStatus={queueStatus}
                    />
                );
            })}

            {queueStatus && (
                <div
                    key="queue-status"
                    className={style["ai-talk-box"]}
                >
                    <strong className={style['ai-avatar']} data-holo="loop">
                        <img src={imgAvata} alt="ai 아바타" />
                    </strong>

                    <div className={style["ai-box"]}>
                        <div className={style["text-box"]} data-layout="loading">
                            <div className={style["p-group"]}>
                                <p>{queueStatus.message}</p>
                            </div>
                            <div className={style["spinner-loading"]}>
                                <CircularProgress size={15} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default React.memo(ChatListComp);